import React from 'react';
import { __ } from 'i18n/index';
import { User } from 'models/User.jsx';
import { Flair } from 'models/Flair.jsx';
import { Dashboard } from '../components/Dashboard';
import { JqueryClassFaker } from "../components/JqueryClassFaker";
import FlairOrAvatar from 'react/flair/FlairOrAvatar';

class UserComponent extends React.Component {
	static defaultProps = {
		showModGavel: true,
		showAt: false,
		captureUsernameClicks: false,
		showIsNew: false,
		showIsNewAsPrefix: false,
		slippiName: false,
		// Chat puts the flair after the name, away from the stock icon before it.
		flairAfterName: false,
		// Chat shows the Discord avatar as the message avatar, not as a stand-in flair.
		avatarAsFlair: true,
	};

	constructor(props) {
		super(props);

		if(this.props.captureUsernameClicks) {
			this.onUsernameClick = (e) => {
				this.usernameClick(e);
			};
		} else {
			this.onUsernameClick = this.props.onClick;
		}
	}

	usernameClick(e) {
		e.stopPropagation();
		Dashboard.UserInfo.loadProfile(this.props.user, {
			x: e.nativeEvent.x,
			y: e.nativeEvent.y
		});
	}


	render() {
		const {
			user,
			unclickable,
			showFrontFlair,
			isChatMod,
			showDisplayName,
			asAnchor,
			showIsNew,
			showIsNewAsPrefix,
			showModGavel,
			flair,
			onContextMenu,
			showTopDonatorFlair,
			forcedGlowColor,
			forcedUserClasses,
			showAt,
			className,
			showUsernameAs,
			captureUsernameClicks,
			showBanned,
			slippiName,
			flairAfterName,
			avatarAsFlair,
			...remainingUserProps
		} = this.props;
		if(!user) {
			return null;
		}
		if(!(user instanceof User)) {
			console.log('got ', user);
			throw new Error('Invalid user object');
		}
		let cssClasses = new JqueryClassFaker();
		if(isChatMod) {
			cssClasses.set('is_chat_mod', '');
		}
		if(showDisplayName && user.display_name) {
			cssClasses.set('has_display_name', '');
		}
		if(showBanned && user.is_banned) {
			cssClasses.set('banned', '');
		}
		cssClasses = forcedUserClasses ? forcedUserClasses : user.cssUsername(cssClasses);
		cssClasses.add(className);
		if(unclickable || this.onUsernameClick) {
			cssClasses.set('unclickable', '');
		}

		const textShadowStyle = user.getTextShadowStyle(forcedGlowColor);

		const UserTag = asAnchor ? `a` : `span`;

		if(asAnchor) {
			remainingUserProps.href = user.getProfileUrl();
		}
		const flairElement = <FlairOrAvatar flair={flair ? user.selected_flair : null} avatarUrl={avatarAsFlair ? user.avatar_url : null} playerId={user.id} />;
		return (
			<React.Fragment>
				{!flairAfterName && flairElement}
				<UserTag
					onContextMenu={onContextMenu}
					style={{
						textShadow: textShadowStyle ? textShadowStyle : null
					}}
					title={cssClasses.getFinalValue()}
					onClick={this.onUsernameClick}
					data-username={user.username}
					data-id={user.id ? user.id : ''}
					className={cssClasses.toString()}
					{...remainingUserProps}
				>
					{showAt &&
					<span className='at'>@</span>
					}
					{showIsNew && user.is_a_new_account && showIsNewAsPrefix &&
					<span className='is_new'>{' '}{__('*new*')}{' '}</span>
					}
					<span className='gangster_name'>
						{!!showUsernameAs &&
						showUsernameAs
						}
						{!showUsernameAs &&
						<React.Fragment>
							{showDisplayName ? user.getStyledUsername() : user.displayedName}
						</React.Fragment>
						}
						{slippiName && user.slippiGameInformation &&
						<React.Fragment>
							{' '}<span>|</span>{' '}
							<span className='slippi-tag'>{user.slippiGameInformation.primary_value}</span>
						</React.Fragment>
						}
                    </span>
					{showDisplayName && !!user.display_name &&
					<span className='display_name'>{user.display_name}</span>
					}
					{showModGavel && (isChatMod || user.isSiteMod()) &&
					<span title='The Gavel Is Power!' className='gavel'><i className='fa fa-gavel' /></span>
					}
					{showIsNew && user.is_a_new_account && !showIsNewAsPrefix &&
					<span className='is_new'>{' '}{__('*new*')}{' '}</span>
					}
				</UserTag>
				{flairAfterName && flairElement}
				{!!showTopDonatorFlair && !!user.is_top_monthly_donator &&
				<FlairComponent flair={Flair.retrieve({
					name: 'dolla',
					safe_url: '/images/smilies/ceo.png',
				}, 'dolla')}
				                className='front_flairy_holder'
				                title={'Is a top 10 donator to the site this month!'}
				/>
				}
			</React.Fragment>
		);
	}

}

class FlairComponent extends React.PureComponent {
	render() {
		if(!this.props.flair) {
			return null;
		}

		const className = this.props.className || 'flairy_holder';

		return (
			<span title={this.props.title} className={className}>
                <img className={'flairy ' + 'flair-' + this.props.flair.name}
                     src={this.props.flair.fullUrl} />
            </span>
		);
	}
}


export { UserComponent };